import { useState, useEffect } from "react";
import { Alert } from "@mui/material";
import moment from 'moment';

interface DeadlineAlertProps {
    deadline: string; // ISO format, e.g., "2025-02-15T23:59:59.000Z"
}

export const DeadlineAlert: React.FC<DeadlineAlertProps> = ({ deadline }) => {
    const [status, setStatus] = useState<"overdue" | "warning" | "safe">("safe");

    useEffect(() => {
        const currentDate = new Date();
        const deadlineDate = new Date(deadline);

        // Convert both dates to UTC time for accurate comparison
        const currentUTC = Date.UTC(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate()
        );
        const deadlineUTC = Date.UTC(
            deadlineDate.getFullYear(),
            deadlineDate.getMonth(),
            deadlineDate.getDate()
        );

        const diffTime = deadlineUTC - currentUTC;
        const diffDays = diffTime / (1000 * 60 * 60 * 24); // Convert to days

        if (diffDays < 0) {
            setStatus("overdue");
        } else if (diffDays <= 3) {
            setStatus("warning");
        } else {
            setStatus("safe");
        }
    }, [deadline]);

    const formatedDate = moment(deadline).format('MMMM Do YYYY hh:mm A');

    return (
        <>
            {status === "safe" && <Alert severity="info">Deadline will be on {formatedDate}</Alert>}
            {status === "overdue" && <Alert severity="error">Deadline has passed on {formatedDate}!</Alert>}
            {status === "warning" && <Alert severity="warning">Deadline is approaching soon on {formatedDate}!</Alert>}
        </>
    );
};